function sendPaymentLink() {
    // console.log("TEST");
    setTimeout(() => {
        const app = document.querySelector('.sk-app[data-process-step-id$=":Payment"]');
        if(!app) return
        
        const button = document.querySelector("#sk-Travel-Messages-SendPaymentLinkMessage button");
        const targetButton = document.querySelector(".send-email-original-button");

        console.log("buttons:", button, targetButton);

        if (!button.dataset.listener) {
            button.dataset.listener = true;
            button.addEventListener("click", (e) => {

                targetButton.click();
                console.log("clicked");
            })
        }
    }, 1000);
}

export { sendPaymentLink };